/**
 * Product Page JavaScript
 * Handles gallery, size selection, tabs, and size calculator
 */

class ProductGallery {
  constructor() {
    this.slides = document.querySelectorAll('.product-gallery__slide');
    this.prevBtn = document.querySelector('[data-slider-prev]');
    this.nextBtn = document.querySelector('[data-slider-next]');
    this.currentSlideEl = document.querySelector('[data-current-slide]');
    this.thumbs = document.querySelectorAll('[data-thumb-index]');
    this.currentSlide = 0;

    this.init();
  }

  init() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.navigateSlide('prev'));
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.navigateSlide('next'));
    }
    this.thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => this.showSlide(parseInt(thumb.dataset.thumbIndex)));
    });
  }

  navigateSlide(direction) {
    if (direction === 'prev') {
      this.showSlide(this.currentSlide === 0 ? this.slides.length - 1 : this.currentSlide - 1);
    } else {
      this.showSlide(this.currentSlide === this.slides.length - 1 ? 0 : this.currentSlide + 1);
    }
  }

  showSlide(index) {
    this.slides.forEach(s => s.classList.remove('active'));
    this.thumbs.forEach(t => t.classList.remove('active'));
    
    if (this.slides[index]) {
      this.slides[index].classList.add('active');
      if (this.thumbs[index]) {
        this.thumbs[index].classList.add('active');
      }
      if (this.currentSlideEl) {
        this.currentSlideEl.textContent = index + 1;
      }
      this.currentSlide = index;
    }
  }
}

class ProductSizeSelector {
  constructor() {
    this.sizeButtons = document.querySelectorAll('[data-size]');
    this.variantInput = document.querySelector('[data-variant-input]');
    this.selectedSizeEl = document.querySelector('[data-selected-size]');
    this.addToCartBtn = document.querySelector('[data-add-to-cart]');
    this.buttonText = document.querySelector('[data-button-text]');

    this.init();
  }

  init() {
    this.sizeButtons.forEach(btn => {
      btn.addEventListener('click', () => this.selectSize(btn));
    });
  }

  selectSize(btn) {
    if (btn.disabled) return;

    this.sizeButtons.forEach(b => b.classList.remove('selected'));
    btn.classList.add('selected');

    if (this.variantInput) {
      this.variantInput.value = btn.dataset.variantId;
    }
    if (this.selectedSizeEl) {
      this.selectedSizeEl.textContent = btn.dataset.size;
    }
    if (this.buttonText) {
      this.buttonText.textContent = 'ADD TO CART';
    }
    if (this.addToCartBtn) {
      this.addToCartBtn.disabled = false;
    }
  }
}

class ProductInfoTabs {
  constructor() {
    this.triggers = document.querySelectorAll('[data-info-tab]');
    this.contents = document.querySelectorAll('[data-tab-content]');
    this.closeButtons = document.querySelectorAll('[data-close-tab]');
    this.items = document.querySelectorAll('.product-info-tabs__item');

    this.init();
  }

  init() {
    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', () => this.toggleTab(trigger));
    });

    this.closeButtons.forEach(btn => {
      btn.addEventListener('click', () => this.resetTabs());
    });
  }

  toggleTab(trigger) {
    const parentItem = trigger.closest('.product-info-tabs__item');
    if (!parentItem) return;

    const targetContent = parentItem.querySelector(`[data-tab-content="${trigger.dataset.infoTab}"]`);
    if (!targetContent) return;

    const wasOpen = parentItem.classList.contains('is-open');
    const isDesktop = window.innerWidth >= 990;
    const productInfo = parentItem.closest('.product-info');

    this.resetTabs();

    if (wasOpen) return;

    parentItem.classList.add('is-open');
    trigger.classList.add('active');
    targetContent.classList.add('is-open');
    
    if (isDesktop && productInfo) {
      productInfo.classList.add('product-info--tab-open');
    }
    
    // Don't auto-scroll on mobile - let user decide
  }

  resetTabs() {
    this.items.forEach(item => item.classList.remove('is-open'));
    this.triggers.forEach(trigger => trigger.classList.remove('active'));
    this.contents.forEach(content => {
      content.classList.remove('is-open');
      content.style.display = '';
    });
    document.querySelectorAll('.product-info--tab-open').forEach(el => {
      el.classList.remove('product-info--tab-open');
    });
  }
}

class SizeCalculator {
  constructor() {
    this.trigger = document.querySelector('[data-size-calc-trigger]');
    this.modal = document.querySelector('[data-size-calculator]');
    this.closeButtons = document.querySelectorAll('[data-modal-close]');
    this.form = document.querySelector('[data-size-calc-form]');
    this.result = document.querySelector('[data-size-result]');
    this.recommendedSizeEl = document.querySelector('[data-recommended-size]');
    this.resultNoteEl = document.querySelector('[data-result-note]');
    this.selectSizeBtn = document.querySelector('[data-select-size]');

    this.init();
  }

  init() {
    if (this.trigger) {
      this.trigger.addEventListener('click', () => this.open());
    }

    this.closeButtons.forEach(btn => {
      btn.addEventListener('click', () => this.close());
    });

    if (this.form) {
      this.form.addEventListener('submit', (e) => this.calculate(e));
    }

    if (this.selectSizeBtn) {
      this.selectSizeBtn.addEventListener('click', () => this.applySize());
    }
  }

  open() {
    if (this.modal) {
      this.modal.style.display = 'block';
    }
  }

  close() {
    if (this.modal) {
      this.modal.style.display = 'none';
    }
    if (this.form) {
      this.form.reset();
      this.form.style.display = 'block';
    }
    if (this.result) {
      this.result.style.display = 'none';
    }
  }

  calculate(e) {
    e.preventDefault();
    
    const height = parseInt(document.getElementById('height').value);
    const weight = parseInt(document.getElementById('weight').value);
    const fit = document.querySelector('input[name="fit"]:checked').value;
    
    const size = this.calculateSize(height, weight, fit);
    
    if (this.recommendedSizeEl) {
      this.recommendedSizeEl.textContent = size;
    }
    if (this.resultNoteEl) {
      this.resultNoteEl.textContent = this.getFitNote(fit);
    }
    if (this.form) {
      this.form.style.display = 'none';
    }
    if (this.result) {
      this.result.style.display = 'block';
    }
  }

  calculateSize(height, weight, fit) {
    const bmi = weight / ((height / 100) ** 2);
    let baseSize;
    
    if (bmi < 18.5) baseSize = 'XS';
    else if (bmi < 21) baseSize = 'S';
    else if (bmi < 24) baseSize = 'M';
    else if (bmi < 27) baseSize = 'L';
    else if (bmi < 30) baseSize = 'XL';
    else baseSize = 'XXL';
    
    const sizes = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'];
    let index = sizes.indexOf(baseSize);
    
    if (fit === 'tight' && index > 0) index--;
    if (fit === 'oversized' && index < sizes.length - 1) index++;
    
    return sizes[index];
  }

  getFitNote(fit) {
    const notes = {
      'tight': 'For a fitted look that hugs your body.',
      'regular': 'For a comfortable true-to-size fit.',
      'oversized': 'For a relaxed, oversized look.'
    };
    return notes[fit] || notes.regular;
  }

  applySize() {
    if (!this.recommendedSizeEl) return;
    
    const recommendedSize = this.recommendedSizeEl.textContent;
    const sizeButtons = document.querySelectorAll('[data-size]');
    const sizeBtn = Array.from(sizeButtons).find(btn => btn.dataset.size === recommendedSize);
    
    if (sizeBtn && !sizeBtn.disabled) {
      sizeBtn.click();
    }
    
    this.close();
  }
}

class ProductForm {
  constructor() {
    this.form = document.querySelector('[data-product-form]');
    this.variantInput = document.querySelector('[data-variant-input]');
    this.errorMessage = document.querySelector('[data-error-message]');
    this.loadingSpinner = document.querySelector('[data-loading-spinner]');
    this.addToCartBtn = document.querySelector('[data-add-to-cart]');
    this.buttonText = document.querySelector('[data-button-text]');

    this.init();
  }

  init() {
    if (this.form) {
      this.form.addEventListener('submit', (e) => this.handleSubmit(e));
    }
  }

  async handleSubmit(e) {
    e.preventDefault();

    if (!this.variantInput) return;

    const variantId = this.variantInput.value;

    if (!variantId) {
      this.showError('Please select a size');
      return;
    }

    this.hideError();
    this.setLoading(true);

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      if (!response.ok) throw new Error('Failed to add to cart');

      this.showSuccess();
    } catch (error) {
      console.error('Error:', error);
      this.showError('Failed to add to cart. Please try again.');
    } finally {
      this.setLoading(false);
    }
  }

  setLoading(loading) {
    if (this.buttonText) {
      this.buttonText.style.display = loading ? 'none' : 'block';
    }
    if (this.loadingSpinner) {
      this.loadingSpinner.style.display = loading ? 'block' : 'none';
    }
    if (this.addToCartBtn) {
      this.addToCartBtn.disabled = loading;
    }
  }

  showSuccess() {
    if (this.buttonText) {
      this.buttonText.textContent = 'ADDED ✓';
      this.buttonText.style.display = 'block';
    }
    
    setTimeout(() => {
      if (this.buttonText) {
        this.buttonText.textContent = 'ADD TO CART';
      }
      if (this.addToCartBtn) {
        this.addToCartBtn.disabled = false;
      }
    }, 2000);
  }

  showError(message) {
    if (this.errorMessage) {
      this.errorMessage.textContent = message;
      this.errorMessage.style.display = 'block';
    }
  }

  hideError() {
    if (this.errorMessage) {
      this.errorMessage.style.display = 'none';
    }
  }
}

class ProductVideo {
  constructor() {
    this.player = document.querySelector('[data-video-player]');
    this.init();
  }

  init() {
    if (this.player) {
      // Attempt to autoplay, catch and ignore errors on browsers that block it
      this.player.play().catch(() => {
        console.log('Autoplay blocked by browser');
      });
    }
  }
}

// Initialize all components when DOM is ready
function initProductPage() {
  new ProductGallery();
  new ProductSizeSelector();
  new ProductInfoTabs();
  new SizeCalculator();
  new ProductForm();
  new ProductVideo();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductPage);
} else {
  initProductPage();
}